import axios from 'axios';

export default {
    fetchAll() {
        return axios.get('[API]/material-types');
    },
    fetchById(id) {
        return axios.get(`[API]/material-types/${id}`);
    },
    create(data) {
        return axios.post('[API]/material-types', data);
    },
    update(id, payload) {
        return axios.put(`[API]/material-types/${id}`, payload);
    },
    delete(id) {
        return axios.delete(`[API]/material-types/${id}`);
    },
    storeAngleDeductions(id, payload) {
        return axios.post(
            `[API]/material-types/${id}/angle-deductions`,
            payload
        );
    },
    duplicate(id) {
        return axios.post(`[API]/material-types/${id}/duplicate`);
    },
};
